import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingFallbackProps {
  message?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'p-2 text-sm',
  md: 'p-4 text-base',
  lg: 'p-6 text-lg'
};

const spinnerSizes = {
  sm: 16,
  md: 20,
  lg: 24
};

export function LoadingFallback({ 
  message = 'Loading...', 
  className = '',
  size = 'md'
}: LoadingFallbackProps) {
  return (
    <div className={`flex flex-col items-center justify-center ${sizeClasses[size]} ${className}`}>
      <Loader2 
        className="animate-spin text-gold-400" 
        size={spinnerSizes[size]} 
      />
      <p className="mt-2 text-gold-200/80">{message}</p>
    </div>
  );
}
